import React, { useEffect } from 'react';
interface BookingModalProps {
  isOpen: boolean;
  onClose: () => void;
}
export function BookingModal({
  isOpen,
  onClose
}: BookingModalProps) {
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isOpen]);
  if (!isOpen) return null;
  return <div className="fixed inset-0 z-50 flex items-center justify-center p-4" data-id="element-131">
      {/* Backdrop */}
      <div className="absolute inset-0 bg-black/60 backdrop-blur-sm animate-fade-in" onClick={onClose} data-id="element-132" />

      {/* Modal */}
      <div className="relative w-full max-w-4xl h-[80vh] bg-white rounded-lg shadow-2xl animate-scale-in overflow-hidden" data-id="element-133">
        {/* Close Button */}
        <button onClick={onClose} className="absolute top-4 right-4 z-10 w-10 h-10 flex items-center justify-center bg-white rounded-full shadow-lg hover:bg-gray-100 transition-colors" aria-label="Close" data-id="element-134">
          <svg className="w-6 h-6 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24" data-id="element-135">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" data-id="element-136" />
          </svg>
        </button>

        {/* Iframe */}
        <iframe src="https://admin.thehireadvantage.co/widget/booking/527yupn7QA040WEr4Ng4" className="w-full h-full border-0" title="Schedule Strategy Call" data-id="element-137" />
      </div>
    </div>;
}